import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import moment from 'moment';
import {getDateFormat} from '../../../Utils/UserFunctions';
import DatePicker from 'react-datetime';
import { Select2 } from "select2-react-component";
import {checkViolationsExist,getViolationsMsg} from '../../../Utils/CommonFunctions';

const CreateNew = (props) => {
	const curState = props.curState;
    const formFields = curState.tax_formfields;
    const countryList = curState.countryList;
    const violations = curState.violations;

	return (
		<Modal size="lg" show={props.modelOpen} onHide={props.toggleModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Tax Details </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-4">
                        <div className={checkViolationsExist('name',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> Name </label>
                            <input type="text" value={formFields.name} name="name" onChange={props.createTaxChangeHandler} className="form-control mandatory" />
                            { checkViolationsExist('name',violations) === true ? 
                                <label className="error m-0">{getViolationsMsg('name',violations)}</label>
                                : null
                            }
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="form-group">
                            <label> Valid from date </label>
                            <DatePicker 
                              timeFormat={false}
                              value={ formFields.valid_from_date ? moment(formFields.valid_from_date).format(getDateFormat('Date')) : ''}
                              onChange={e=>props.filterOnChange(e)}
                              closeOnSelect={true}
                              dateFormat={getDateFormat()}
                            />
                        </div>
                    </div>

                    <div className="col-4">
                        <div className={checkViolationsExist('fromCountry',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> From Country </label>
                            { countryList.length > 0 ?
                                <div className="mandatory select2-arrow">
                                    <Select2 data={countryList}
                                        value={formFields.from_country}
                                        minCountForSearch ={1}
                                        update={value => props.select2OnChangeHandler(value,'from_country')}
                                        className="mandatory"
                                        >
                                    </Select2>
                                </div> 
                                : 
                                <select className="form-control" name='from_country' onChange={props.createTaxChangeHandler} value={formFields.from_country}>
                                    <option value=''></option>
                                </select>
                            }
                            { checkViolationsExist('fromCountry',violations) === true ? 
                                <label className="error m-0">{getViolationsMsg('fromCountry',violations)}</label>
                                : null
                            }
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="form-group">
                            <label> From Region </label>
                            <input type="text" value={formFields.from_province} name="from_province" onChange={props.createTaxChangeHandler} className="form-control" />
                        </div>
                    </div>

                    <div className="col-4">
                        <div className={checkViolationsExist('toCountry',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> To Country </label>
                            { countryList.length > 0 ?
                                <div className="mandatory select2-arrow">
                                    <Select2 data={countryList}
                                        value={formFields.to_country}
                                        minCountForSearch ={1}
                                        update={value => props.select2OnChangeHandler(value,'to_country')}
                                        >
                                    </Select2> 
                                </div>
                                : 
                                <select className="form-control" name='to_country' onChange={props.createTaxChangeHandler}value={formFields.to_country}>
                                    <option value=''></option>
                                </select>
                            }
                            { checkViolationsExist('toCountry',violations) === true ? 
                                <label className="error m-0">{getViolationsMsg('toCountry',violations)}</label>
                                : null
                            }
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="form-group">
                            <label> To Region </label>
                            <input type="text" value={formFields.to_province} name="to_province" onChange={props.createTaxChangeHandler} className="form-control" />
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="form-group">
                            <label> Tax Excempt </label>
                            <div className="material-switch">
                            <input 
                                id="tax_exempt" name="tax_exempt"
                                type="checkbox" 
                                onChange={props.createTaxChangeHandler}
                                checked={(formFields.tax_exempt === 'true' || formFields.tax_exempt === true) ? true : false}
                            />
                            <label htmlFor="tax_exempt" className="secondary_bg"></label>
                            </div>
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="form-group">
                            <label> Rate </label>
                            <input type="text" value={formFields.rate} name="rate" onChange={props.createTaxChangeHandler} className="form-control" />
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                
                    <a onClick={props.toggleModel} className="btn btn-cancel mr-2"> Cancel </a> 
                    <a onClick={props.saveTaxDetails} className="btn primary_bg"> Save </a> 
           
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(CreateNew);